import React from 'react';
import { Shield, AlertTriangle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PermissionDenied = ({
  title,
  message,
  showBackButton = true
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('permissionDenied.defaultTitle');
  const resolvedMessage = message ?? t('permissionDenied.defaultMessage');
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-xl border border-gray-200 p-8 text-center">
        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <Shield className="h-8 w-8 text-red-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">{resolvedTitle}</h1>

        <p className="text-gray-600 mb-6">{resolvedMessage}</p>

        {showBackButton && (
          <Link
            to="/management"
            className="inline-flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>{t('permissionDenied.backToDashboard')}</span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default PermissionDenied; 